<ng-container *transloco="let t; prefix: 'group-management.panels.send-message'">
  @if (participants().length > 0) {
    <app-panel-body>
      <div class="flex min-h-0 flex-1 flex-col text-sm text-primary-text">
        <div class="min-h-0 flex-1 overflow-y-auto">
          <app-content-container>
            <div class="space-y-4">
              <label class="mb-1 block font-medium" for="participant-message-body">
                {{ t('message-label') }}
              </label>
              <textarea
                id="participant-message-body"
                class="min-h-40 w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm text-primary-text"
                [ngModel]="messageBody()"
                (ngModelChange)="messageBody.set($event)"
              ></textarea>
              @if (isBulk()) {
                <p class="text-center text-secondary-text">
                  {{ t('delivered-to-bulk', { count: participants().length }) }}
                </p>
              } @else {
                <p class="text-center text-secondary-text">
                  {{ t('delivered-to', { email: participants()[0].email }) }}
                </p>
              }
            </div>
          </app-content-container>
        </div>
        <div class="flex shrink-0 justify-end gap-3 border-t border-primary-border px-4 py-4">
          <button
            type="button"
            class="rounded-md border border-primary-border bg-primary-bg px-4 py-2 text-sm font-semibold text-primary-text hover:bg-secondary-bg"
            (click)="cancel()"
            [disabled]="submitting()"
          >
            {{ t('cancel') }}
          </button>
          <button
            type="button"
            class="rounded-md bg-teal px-4 py-2 text-sm font-semibold text-white hover:bg-teal-600 disabled:opacity-50"
            (click)="confirm()"
            [disabled]="submitting() || !messageBody().trim()"
          >
            {{ t('send') }}
          </button>
        </div>
      </div>
    </app-panel-body>
  }
</ng-container>
